module.exports = __webpack_public_path__ + "static/media/download-white.b0877e8e.svg";